// @ts-nocheck
/**
 * "Submit for them" — the coach built the roster on RecruitLook and never
 * clicked submit, which blocks scheduling. RLE sends no player data: it asks RL
 * to flip the status it already holds, and shows RL's refusal plainly.
 */
import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

export default function SubmitRosterDialog({
  open,
  onOpenChange,
  teamName,
  playerCount,
  minimum,
  onSubmit,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  teamName: string;
  playerCount: number;
  minimum: number;
  onSubmit: (reason: string) => Promise<{ ok: boolean; error?: string }>;
}) {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (open) {
      setReason("");
      setError(null);
    }
  }, [open]);

  const go = async () => {
    setBusy(true);
    setError(null);
    const res = await onSubmit(reason.trim());
    setBusy(false);
    if (res.ok) onOpenChange(false);
    else setError(res.error || "RecruitLook refused this submission.");
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Submit this roster for {teamName || "the team"}</DialogTitle>
          <DialogDescription>
            RecruitLook keeps the players. This only marks the roster as submitted, so
            scheduling can go ahead — {playerCount} player{playerCount === 1 ? "" : "s"} on
            the roster, minimum {minimum}.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-2">
          <Label htmlFor="submit-reason">Reason (optional)</Label>
          <Textarea
            id="submit-reason"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Coach confirmed by phone; roster complete."
            rows={3}
          />
        </div>

        {error && (
          <p className="rounded-md bg-destructive/10 px-3 py-2 text-sm text-destructive">
            {error}
          </p>
        )}

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={busy}>
            Cancel
          </Button>
          <Button onClick={go} disabled={busy}>
            {busy ? "Submitting…" : "Submit roster"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
